<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div class="col-12 mt-4">
		<b-modal
			ref="loaderModal"
			hide-footer
			title="Loading..."
		>
			<throbber />
			<p class="my-4">{{ $t('Tooltip.message_wait') }}</p>
		</b-modal>
		<b-modal
			ref="modalError"
			hide-footer
			title="Erreur"
		>
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<div class="valid_button">
			<button
				type="submit"
				class="btn btn-valid"
				@click="sendDatas"
			>{{ $t('Button.validate') }}
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import {EventBus} from "../../../event/event-bus.js";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "validstepbuttonkeynumber",
	components: {lottie_error, throbber},
	props: {
		keyPairs: Array,
		id: Number,
		modal: "",
		music_enabled: Boolean,
		music_volume: Number,
	},
	data() {
		return {
			successModif: "L'étape Chiffres clés a été modifiée avec succès !",
			text_error: "",
		};
	},
	methods: {
		sendDatas() {
			let $this = this;
			$this.$refs.loaderModal.show();
			let bodyFormData = new FormData();
			bodyFormData.append("_method", "put");
			if ($this.keyPairs.length > 0) {
				bodyFormData.append("keyPairs", JSON.stringify($this.keyPairs));
				bodyFormData.append("isCompleted", "1");
			}

			if (this.music_enabled !== undefined) {
				bodyFormData.append("music_enabled", this.music_enabled ? "true" : "false");
			}
			if (this.music_volume !== undefined) {
				bodyFormData.append("music_volume", this.music_volume.toString());
			}

			axios.post(BASE_URL + "/public/api/stepKeynumbers/" + this.id,
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.$refs.loaderModal.hide();
				if ($this.keyPairs.length > 0) {
					EventBus.$emit("setStepKeynumberComplete", $this.id);
					EventBus.$emit("setModified", false);
				}
			})
				.catch(error => {
					$this.text_error = this.$root.$t("Errors.error_detailed") + e;
					$this.$refs.modalError.show();
				});
		},
	},
};
</script>

<style>
.btn-valid {
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
	border-radius: var(--small-border-radius);
}

.btn-valid:hover {
	color: var(--text-validation);
}

</style>
